import { getMessages } from '../../../../../../../store/constants';

export const DATEPICKER_DATE_BUTTON_AM = getMessages().getText('datepicker.date_button.am');
export const DATEPICKER_DATE_BUTTON_PM = getMessages().getText('datepicker.date_button.pm');
